import { useEffect } from "react";
import { parseFragmentParameters } from "@/config/unified-search-config";

const useFragmentParser = () => {
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash.includes("#q/")) {
      // Defer URL update to avoid render-time router updates
      const timer = setTimeout(() => {
        parseFragmentParameters(true);
      }, 0);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);
  return undefined;
};

export default useFragmentParser;